import { createSelector } from 'reselect'
import { formatLibraryType } from 'helpers/libraryTypeFormatter'
import libraryTypes from 'helpers/enums/libraryTypes'

const myLibrarySelector = state => state.myLibrary
const ltiSelector = state => state.lti

const myLibraryLaunchLessonSelector = createSelector(
	[myLibrarySelector, ltiSelector],
	(myLibrary, lti) => {
		const libraryType = formatLibraryType(lti)
		return {
			libraryType,
			uid: libraryType === libraryTypes.LTI ? lti.canvas : libraryTypes.TEAMS,
			ltiForwardUrl: lti.ltiForwardUrl,
		}
	}
)

export default myLibraryLaunchLessonSelector
